import { ButtonPermissionMap } from '../../constant/ButtonPermission'
export default [
  {
    name: 'benefit_manage',
    path: '/benefit_manage',
    component: () =>
      import(
        /* webpackChunkName: "benefit_manage" */ './BenefitManage/BenefitManage.vue'
      )
  },
  {
    name: 'point_benefit_manage',
    path: '/point_benefit_manage',
    component: () =>
      import(
        /* webpackChunkName: "point_benefit_manage" */ './PointBenefitManage/BenefitManage.vue'
      )
  },
  {
    name: 'banner',
    path: '/banner',
    component: () =>
      import(/* webpackChunkName: "banner" */ './BannerManage.vue')
  },
  {
    name: 'banner_detail',
    path: '/banner_detail',
    meta: {
      permission: ButtonPermissionMap.Banner_Detail
    },
    component: () =>
      import(/* webpackChunkName: "banner" */ './BannerDetail.vue')
  },
  {
    name: 'membertype',
    path: 'membertype',
    component: () =>
      import(
        /* webpackChunkName: "membertype" */ '@/projects/teller/views/Staff/StaffList.vue'
      )
  },
  {
    name: 'membertype_detail',
    path: 'membertype/detail',
    component: () =>
      import(
        /* webpackChunkName: "membertype" */ '@/projects/teller/views/Staff/StaffEdit.vue'
      )
  },
  {
    name: 'roleManage',
    path: 'roleManage',
    component: () =>
      import(/* webpackChunkName: "roleManage" */ './NewRole.vue')
  },
  {
    name: 'MerchantBizScopeMgmt',
    path: 'merchant_biz_scope_mgmt',
    component: () =>
      import(/* webpackChunkName: "roleManage" */ './MerchantBizScopeMgmt.vue')
  },
  {
    name: 'systemParameterManage',
    path: 'systemParameterManage',
    component: () =>
      import(
        /* webpackChunkName: "systemParameterManage" */ './SystemParams.vue'
      )
  },
  {
    name: 'bussiness_monitor',
    path: '/bussiness_monitor',
    component: () =>
      import(
        /* webpackChunkName: "bussiness_monitor" */ './BusinessMonitor.vue'
      )
  },
  {
    name: 'register_staff',
    path: '/register_staff',
    component: () =>
      import(
        /* webpackChunkName: "register_staff" */ '@/projects/teller/views/Staff/StaffRegister.vue'
      )
  },
  {
    name: 'password_reset',
    path: '/password_reset',
    component: () =>
      import(
        /* webpackChunkName: "password_reset" */ '@/projects/teller/views/Staff/ResetStaffPassword.vue'
      )
  },
  {
    name: 'frontend-content-manage',
    path: '/frontend_content_manage',
    component: () =>
      import(
        /* webpackChunkName: "frontend_content_manage" */ './FrontEndContentMange/Index.vue'
      )
  },
  {
    name: 'promotion_resource_config',
    path: '/promotion_resource_config',
    component: () =>
      import(
        /* webpackChunkName: "promotion_resource_config" */ './PromotionResourceConfig/Index.vue'
      )
  },
  {
    name: 'HotUpdate',
    path: '/app_hotupdate',
    meta: {
      auth: false
    },
    component: () =>
      import(/* webpackChunkName: "app_hotupdate" */ './HotUpdate.vue')
  }
]
